import { AppStarted, goToTest } from './app/routing/events'
import WebApp from '@twa-dev/sdk'
import { environment } from './shared/constants'

export function init() {
  AppStarted()
  WebApp.ready()
  WebApp.expand()
  WebApp.enableClosingConfirmation()
  WebApp.disableVerticalSwipes()
  // test
  if (environment == 'dev' || environment == 'stage') {
    WebApp.SettingsButton.show()
    WebApp.SettingsButton.onClick(() => {
      goToTest()
    })
  }
}
